var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-section-container"},[_c(_vm.isCatalogType ? _vm.CatalogLoader : _vm.DynamicSectionLoader,{directives:[{name:"on-display",rawName:"v-on-display",value:(_vm.sectionInfo),expression:"sectionInfo"}],tag:"component",attrs:{"catalog-info":_vm.catalog,"section-info":_vm.sectionInfo,"multisection-index":_vm.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }